import type React from 'react';

import Typography from '../../Typography';

export interface StatsNumberProps {
  children: React.ReactNode;
}

const StatsNumber = ({ children }: StatsNumberProps) => {
  const numberFormatter = Intl.NumberFormat('pt-BR');

  if (typeof children !== 'string' && typeof children !== 'number') return children;
  return (
    <Typography variant='button-label' className='min-w-[18px] text-right'>
      {(typeof children !== 'number' && numberFormatter.format(Number(children))) || children}
    </Typography>
  );
};

StatsNumber.displayName = 'Stats.Number';

export default StatsNumber;
